// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6z_zg","right":"styles_right__ToNTw"};